export default __webpack_public_path__ + "static/images/jpegIcon.4544f04f.svg";